import { combineReducers } from 'redux'
import { routerReducer as routing } from 'react-router-redux'

import account from './account'
import announcements from './announcements'
import availableBuildings from './available_buildings'
import balance from './balance'
import buildingConstruction from './building_construction'
import buildings from './buildings'
import buildingUpgrade from './building_upgrade'
import challenges from './challenges'
import challengesResults from './challenges_results'
import clan from './clan'
import clanMembersOnline from './clan_members_online'
import clanReserves from './clan_reserves'
import commandCenterUpgrade from './command_center_upgrade'
import craftMachine from './craft_machine'
import fortBattleResults from './fort_battle_results'
import globalMap from './global_map'
import journal from './journal'
import locale from './locale'
import leaderboard from './leaderboard'
import players_matching from './players_matching'
import recommendedClans from './recommended_clans'
import reserveActivation from './reserve_activation'
import reserveProduce from './reserve_produce'
import reserveProduceCancel from './reserve_produce_cancel'
import schedule from './schedule'
import settings from './settings'
import shop from './shop'
import slots from './slots'
import stronghold from './stronghold'
import toolbar from './toolbar'
import userFlags from './user_flags'
import webbrg from './webbrg'
import wgcwxBattleSchedule from './wgcwx_battle_schedule'
import wgcwxLeaderboards from './wgcwx_leaderboards'
import clanQuests from './clanQuests'
import client from './client'
import clientCounters from './client_counters'
import comparisonBasket from './comparison_basket'
import migrationScreen from './migration_screen'
import availablePeripheries from './available_peripheries'
import clanInvites from './clan_invites'
import greetingLanding from './greeting_landing'
import strongholdManeuvers from './stronghold_maneuvers'

import { reducers as cmtReducers } from './CMT'
import { reducers as unitReducers } from './units'
import { reducers as wgcwxShopReducers } from './wgcwx_shop'

export const reducers = {
    ...cmtReducers,
    ...unitReducers,
    ...wgcwxShopReducers,
    account,
    announcements,
    availableBuildings,
    balance,
    buildingConstruction,
    buildings,
    buildingUpgrade,
    challenges,
    challengesResults,
    clan,
    clanMembersOnline,
    clanReserves,
    commandCenterUpgrade,
    comparisonBasket,
    craftMachine,
    fortBattleResults,
    globalMap,
    journal,
    leaderboard,
    locale,
    players_matching,
    recommendedClans,
    reserveActivation,
    reserveProduce,
    reserveProduceCancel,
    routing,
    schedule,
    settings,
    shop,
    slots,
    stronghold,
    toolbar,
    userFlags,
    webbrg,
    wgcwxBattleSchedule,
    wgcwxLeaderboards,
    clanQuests,
    client,
    clientCounters,
    migrationScreen,
    availablePeripheries,
    clanInvites,
    greetingLanding,
    strongholdManeuvers,
}

export default combineReducers(reducers)



// WEBPACK FOOTER //
// ./state/reducers/index.js